module.exports = __webpack_public_path__ + "img/hanqing.d482567c.png";